import * as React from 'react';

var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPmCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 6.75,
    width: 32.5,
    height: 20.5,
    rx: 3.25,
    fill: "#CCEEDC",
    stroke: "#4DC484",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23c2.222-2.121 3.333-3.818 3.333-5.09C20.333 16 19.667 16 19 16c-.667 0-1.355.69-1.333 1.91.022 1.302 1.105 3.103 1.666 3.817 1 1.273 1.667 1.591 2.334.637L23 20.454c.222 1.698.889 2.546 2 2.546.353 0 1.76-1.273 2-1.273.345 0 1.011.425 2 1.273",
    stroke: "#4DC484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5v3M8 18.5v3M8 7.5v2M8 24.5v2",
    stroke: "#4DC484",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export { SvgPmCheck as ReactComponent };
